import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-popup-info-altima',
  standalone: true,
  imports: [TranslateModule, ButtonModule],
  templateUrl: './popup-info-altima.component.html',
  styleUrl: './popup-info-altima.component.scss'
})
export class PopupInfoAltimaComponent implements OnInit {

  
  constructor() {
    
    
  }

  ngOnInit(): void {
    
  }
}
